// 034 (propio de LogiaCare) — rangos plausibles. El formulario guarda un peso y, opcionalmente, la edad gestacional.
export const PESO_GESTANTE_MIN_KG = 30;
export const PESO_GESTANTE_MAX_KG = 200;
export const SEMANAS_GESTACION_MIN = 1;
export const SEMANAS_GESTACION_MAX = 45;

export interface ErroresValidacion034 {
  /** Clave i18n bajo `formularios.f034`. */
  readonly peso?: 'errorPeso';
  readonly edadGestacional?: 'errorEdadGestacional';
}

/** `''` = vacío. El peso es obligatorio; la edad gestacional, opcional pero, si viene, 1-45 semanas. */
export function validar034(peso: number | '', edadGestacional: number | ''): ErroresValidacion034 {
  const errores: { peso?: 'errorPeso'; edadGestacional?: 'errorEdadGestacional' } = {};
  if (peso === '' || !Number.isFinite(peso) || peso < PESO_GESTANTE_MIN_KG || peso > PESO_GESTANTE_MAX_KG) errores.peso = 'errorPeso';
  if (edadGestacional !== '' && (!Number.isFinite(edadGestacional) || edadGestacional < SEMANAS_GESTACION_MIN || edadGestacional > SEMANAS_GESTACION_MAX)) {
    errores.edadGestacional = 'errorEdadGestacional';
  }
  return errores;
}
